/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { generateSimplestList, SimpleAttributeList, simpleLocalAttribute } from './SimpleAttribute';
import { DefaultSplitDataRenderType, SplitData } from './SplitData';
import { Role } from './Role';
import { User } from './User';

export interface ISecondaryRole {
	[key: string]: string;
}

//don't think a constructor is actually of any value
// eslint-disable-next-line @typescript-eslint/naming-convention
export interface BaseProjectMemberFields {
	accessLevel: 'General' | 'Admin';
	projectMemberId: string;
	roleId?: string;
	userId: string;
	secondaryRoles?: ISecondaryRole;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface ProjectMemberFields extends BaseProjectMemberFields {
	role: Role;
	user: User;
}

export class ProjectMember extends SplitData<ProjectMemberFields, DefaultSplitDataRenderType> {
	protected useInPlace: boolean = true;
	protected attributeList: SimpleAttributeList = Object.assign(
		generateSimplestList(['accessLevel', 'projectMemberId', 'roleId', 'userId', 'secondaryRoles']),
		{
			role: simpleLocalAttribute,
			user: simpleLocalAttribute,
		}
	);

	public constructor(id: string) {
		super(id, DefaultSplitDataRenderType.database);
	}

	// This is needed to set a secondaryRoles for newly invited users that was assigned only one role.
	// In that case secondaryRoles is undefined and shows errors in console (Related to: TP-842)
	// eslint-disable-next-line @typescript-eslint/naming-convention
	private recalcLocal(renderType?: DefaultSplitDataRenderType): void {
		if (!renderType) {
			renderType = this.currentRenderType;
		}
		const view = this[renderType];
		if (!view.secondaryRoles && view.roleId) {
			view.secondaryRoles = { [view.roleId]: view.roleId };
		}
	}

	// override
	public databaseUpdate(data: object): void {
		super.databaseUpdate(data);
		this.recalcLocal(DefaultSplitDataRenderType.database);
	}
}
